var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { MarathonNode } from "../resources/Marathon.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { MarathonYearScalar } from "../scalars/MarathonYear.js";
import { IsAfterDateTime, IsBeforeDateTime, } from "../validation/beforeAfter.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListMarathonsResponse = class ListMarathonsResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [MarathonNode], { nullable: false }),
    __metadata("design:type", Array)
], ListMarathonsResponse.prototype, "data", void 0);
ListMarathonsResponse = __decorate([
    ObjectType("ListMarathonsResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListMarathonsResponse);
export { ListMarathonsResponse };
let CreateMarathonInput = class CreateMarathonInput {
    year;
    startDate;
    endDate;
};
__decorate([
    Field(() => MarathonYearScalar, { nullable: false }),
    __metadata("design:type", String)
], CreateMarathonInput.prototype, "year", void 0);
__decorate([
    IsBeforeDateTime("endDate"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreateMarathonInput.prototype, "startDate", void 0);
__decorate([
    IsAfterDateTime("startDate"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreateMarathonInput.prototype, "endDate", void 0);
CreateMarathonInput = __decorate([
    InputType()
], CreateMarathonInput);
export { CreateMarathonInput };
let SetMarathonInput = class SetMarathonInput {
    year;
    startDate;
    endDate;
};
__decorate([
    Field(() => MarathonYearScalar, { nullable: false }),
    __metadata("design:type", String)
], SetMarathonInput.prototype, "year", void 0);
__decorate([
    IsBeforeDateTime("endDate"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], SetMarathonInput.prototype, "startDate", void 0);
__decorate([
    IsAfterDateTime("startDate"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], SetMarathonInput.prototype, "endDate", void 0);
SetMarathonInput = __decorate([
    InputType()
], SetMarathonInput);
export { SetMarathonInput };
let ListMarathonsArgs = class ListMarathonsArgs extends FilteredListQueryArgs("MarathonResolver", ["year", "startDate", "endDate", "createdAt", "updatedAt"]) {
};
ListMarathonsArgs = __decorate([
    ArgsType()
], ListMarathonsArgs);
export { ListMarathonsArgs };
//# sourceMappingURL=ListMarathonsResponse.js.map